import React, { Fragment, useEffect, useState } from "react";
import t from "../../../helpers/t";
import { Biscuit } from "../../../../utils";
import { helpMessageItemsActions, useSelector } from "inbooma-api";

const HelpMessageItemAddition = (props) => {
  const { helpMessageItems, helpMessage, dispatch } = props;
  const _deleteHelpMessageItem = useSelector(
    (state) => state["help_message_items_data"].deleteHelpMessageItem,
  );
  const [localHelpMessageItems, setLocalHelpMessageItems] = useState(helpMessageItems);
  const [deleteHelpMessagePending, setDeleteHelpMessagePending] = useState(null);

  // Keep the local list in sync when the parent passes new items
  useEffect(() => {
    setLocalHelpMessageItems(helpMessageItems);
  }, [helpMessageItems]);

  useEffect(() => {
    if (deleteHelpMessagePending === null || _deleteHelpMessageItem.success === "") return;
    if (_deleteHelpMessageItem.success === true) {
      setLocalHelpMessageItems((prevItems) => {
        const newHelpMessageItems = prevItems.slice(0);
        newHelpMessageItems.splice(deleteHelpMessagePending, 1);
        return newHelpMessageItems;
      });
    }
    setDeleteHelpMessagePending(null);
  }, [_deleteHelpMessageItem, deleteHelpMessagePending]);

  const deleteAction = (e, index, helpMessageItem) => {
    dispatch(
      helpMessageItemsActions.deleteHelpMessageItem({
        token: Biscuit.get("token"),
        id: helpMessageItem.id,
      }),
    );
    setDeleteHelpMessagePending(index);
  };

  return (
    <>
      <header className="inb-c-item-details__header small-12 column">
        <a
          href={
            "help_messages/" + helpMessage.id + "/add?path=/help_messages&item=" + helpMessage.id
          }
          className="inb-c-item-add inb-resource-manage small button beautify float-right"
          data-inb-help-message-id={helpMessage.id}
          data-inb-action-link="write"
        >
          {" "}
          {t("add_${a}", { a: t("help message item") })}{" "}
        </a>
        {typeof localHelpMessageItems !== "undefined" && localHelpMessageItems.length === 0 && (
          <span className="inb-list-title">{t("no_linked_resources")}</span>
        )}
        {typeof localHelpMessageItems !== "undefined" && (
          <span className="inb-list-title">
            {t("linked_resources") + " " + localHelpMessageItems.length}
          </span>
        )}
      </header>
      {typeof localHelpMessageItems !== "undefined" &&
        localHelpMessageItems.length > 0 &&
        localHelpMessageItems.map((helpMessageItem, index) => {
          return (
            <Fragment key={helpMessageItem.id}>
              <div
                className="inb-help-message-item inb-c-item-details-row row padding-left-10"
                data-inb-help-message-item-id={helpMessageItem.id}
                data-inb-context="help-message-items"
                style={{ paddingLeft: "10px" }}
              >
                <div className="medium-1 small-2 column inb-help-message-item__id">
                  #{helpMessageItem.position}
                </div>
                <div className="medium-2 small-2 column inb-help-message-item__title">
                  {helpMessageItem.title}
                </div>
                <div className="medium-1 small-2 column inb-help-message-item__content">
                  {helpMessageItem.content}
                </div>
                <div className="medium-1 small-2 column inb-help-message-item__image">
                  {helpMessageItem.image}
                </div>
                <div className="medium-1 small-2 column inb-certificate__fontSize">
                  {helpMessageItem.fontSize}
                </div>
                <div className="large-2 medium-12 small-2 column text-right">
                  <div className="row">
                    <div className="medium-8 small-6 column text-right">
                      <a
                        className="inb-help-message-item__edit inb-c-item__edit"
                        href={
                          "help_messages/" +
                          helpMessage.id +
                          "/" +
                          helpMessageItem.id +
                          "?path=/help_messages&item=" +
                          helpMessage.id
                        }
                        data-inb-action-link="edit"
                      >
                        <i className="fi fi-wrench"></i>
                      </a>
                    </div>
                    <div className="medium-4 small-6 column text-left">
                      <a
                        className="inb-help-message-item__remove inb-c-item__remove"
                        href="#"
                        onClick={(e) => deleteAction(e, index, helpMessageItem)}
                        data-inb-action-link="remove"
                        title={t("delete_${a}", { a: t("help message item") })}
                      >
                        <i className="fi fi-trash"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </Fragment>
          );
        })}
    </>
  );
};
export default HelpMessageItemAddition;
